import React, { useEffect, useState } from "react";
import {
  CallStatus as CallStatusT,
  useDeviceStateSubscriptionQuery
} from "generated/graphql";
import { useTranslation } from "utilities/i18n";
import { SECOND_IN_MILLISECONDS } from "Constants";

const CallStatus: React.FC<{
  id?: string;
}> = ({ id }) => {
  const { t } = useTranslation();
  const [supported, setSupported] = useState(true);
  const pause = !(supported && !!id);
  const { data, error } = useDeviceStateSubscriptionQuery({
    variables: {
      id: id ?? ""
    },
    pause,
    requestPolicy: "cache-and-network",
    pollInterval: 10 * SECOND_IN_MILLISECONDS
  });
  const status = data?.device.callStatus;

  useEffect(() => {
    if (status === CallStatusT.Unsupported) {
      setSupported(false);
    } else if (error) {
      setSupported(false);
    }
  }, [status, error]);

  if (!data) {
    return <></>;
  }

  switch (data.device.callStatus) {
    case CallStatusT.InCall:
      return <div className="ml-1 badge success">{t("ACTIVE_CALL")}</div>;
    case CallStatusT.Unknown:
    case CallStatusT.NotInCall:
    case CallStatusT.Unsupported:
    default:
      return <></>;
  }
};
export default CallStatus;
